// Typelizer digest b0db680244a9ce711b81cb24cccd3a27
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/recurring_invoices */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/recurring_invoices */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/recurring_invoices/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/new', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/recurring_invoices/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/recurring_invoices/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/recurring_invoices/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:id', params, options),
    method: 'delete',
  }),
}
